import { groupTimesByServiceWindow } from '@shared/availability/availabilityUtil';
import type { Availability } from 'webReservations/restaurant/apiHelpers';
import type { AvailabilityImpressionSnapshot } from './guestPricingTypes';

export const serializeAvailabilityForImpression = (
  availability: Availability,
): AvailabilityImpressionSnapshot => ({
  listingId: availability.listing.id,
  date: availability.date,
  time: availability.time,
  purchasePrice: availability.purchasePrice,
  guestCount: availability.guestCount,
  isBestAvailable: availability.isBestAvailable,
  isFeaturedUpgrade: availability.isFeaturedUpgrade,
  serviceWindow: availability.serviceWindow,
});

export const selectAvailabilitiesForPricingImpression = ({
  filteredAvailabilities,
  filteredAvailabilitiesGroupedByTime,
  selectedFloorPlanListingIds,
  selectedTime,
  serviceWindowIndex,
}: {
  filteredAvailabilities: Availability[];
  filteredAvailabilitiesGroupedByTime: Record<string, Availability[]>;
  selectedFloorPlanListingIds: string[];
  selectedTime: string | null;
  serviceWindowIndex: number;
}): AvailabilityImpressionSnapshot[] => {
  if (selectedFloorPlanListingIds.length > 0) {
    return filteredAvailabilities.map(serializeAvailabilityForImpression);
  }

  if (selectedTime) {
    const atTime = filteredAvailabilitiesGroupedByTime[selectedTime] ?? [];
    return atTime
      .filter((a) => a.isBestAvailable || a.isFeaturedUpgrade)
      .map(serializeAvailabilityForImpression);
  }

  const groups = groupTimesByServiceWindow(filteredAvailabilitiesGroupedByTime);
  const safeIndex = Math.min(
    serviceWindowIndex,
    Math.max(0, groups.length - 1),
  );
  const timesInWindow = groups[safeIndex]?.[1] ?? [];

  return timesInWindow
    .flatMap((time) =>
      (filteredAvailabilitiesGroupedByTime[time] ?? []).filter(
        (a) => a.isBestAvailable,
      ),
    )
    .map(serializeAvailabilityForImpression);
};
